import { render, staticRenderFns } from "./gerenPaciente.vue?vue&type=template&id=cf063a8a&scoped=true&"
import script from "./gerenPaciente.vue?vue&type=script&lang=js&"
export * from "./gerenPaciente.vue?vue&type=script&lang=js&"
import style0 from "./gerenPaciente.vue?vue&type=style&index=0&id=cf063a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf063a8a",
  null
  
)

export default component.exports